// Generated by purs version 0.14.4
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Builder_Class from "../Specular.Dom.Builder.Class/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Extra from "../Specular.FRP.Extra/index.js";
import * as Utils_Elm_Specular from "../Utils.Elm.Specular/index.js";
var widgetHoliday = function (h) {
    return Specular_Dom_Element.el_("div")(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("m-restaurant-hours__item") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("m-restaurant-hours__header") ])(Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.text(Data_Record.getField(Data_Record.hasFieldRecord({
        reflectSymbol: function () {
            return "duration";
        }
    })())(Data_Symbol.SProxy.value)(h)))(function () {
        return Specular_Dom_Builder_Class.rawHtml(Specular_Dom_Builder.monadDomBuilderBuilder)("&nbsp;");
    })))(function () {
        return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("m-restaurant-hours__data-wrapper") ])(Specular_Dom_Element.text(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "description";
            }
        })())(Data_Symbol.SProxy.value)(h))))(function () {
            return Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("clearfix") ])(Specular_Dom_Element.text(""));
        });
    })))(function () {
        return Specular_Dom_Element.el("span")([ Specular_Dom_Element.class_("m-restaurant-hours__info") ])(Specular_Dom_Element.text(Data_Record.getField(Data_Record.hasFieldRecord({
            reflectSymbol: function () {
                return "info";
            }
        })())(Data_Symbol.SProxy.value)(h)));
    }));
};
var widget = function (config) {
    return function (stateD) {
        return function (v) {
            return Specular_Dom_Element.el("div")([ Specular_Dom_Element.class_("m-restaurant-hours " + Data_Record.getField(Data_Record.hasFieldRecord({
                reflectSymbol: function () {
                    return "modifierClasses";
                }
            })())(Data_Symbol.SProxy.value)(config)) ])(Specular_FRP_Extra.forDyn_(Specular_Dom_Builder.monadReplaceBuilder)(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Data_Foldable.foldableArray)(stateD)(function (holiday) {
                return widgetHoliday(holiday);
            }));
        };
    };
};
var view = function (config) {
    return Utils_Elm_Specular.specularView(widget(config));
};
export {
    view,
    widget
};
//# sourceMappingURL=index.js.map
